import { OrderedListProps } from "../../Types/CommonElementType";

const OL: React.FC<OrderedListProps> = (props) => {
  const { children = "" } = props;
  return <ol {...props}>{children}</ol>;
};

export default OL;
